import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import LargeButton from '../../../../common/src/components/LargeButton';
import useSessionId from '../../../../flows/src/hooks/useSessionId';
import useIsNewRoute from '../../features/offers/hooks/useIsNewRoute';

interface Props {
  riskObject: string;
}

const SelectedOffersEmptyRiskObjContainer: React.FC<
  React.PropsWithChildren<Props>
> = ({ riskObject }) => {
  const { t } = useTranslation();
  const sessionId = useSessionId();
  const history = useHistory();
  const isNewRoute = useIsNewRoute();

  return (
    <Container>
      <Title>
        {t('It seems like you did not select a x insurance', {
          riskObj: t(riskObject).toLowerCase(),
        })}
      </Title>
      <Description>
        {t(
          'According to your profile, a x insurance is recommended Consider adding one anyway',
          { riskObj: t(riskObject).toLowerCase() },
        )}
      </Description>
      <LargeButton
        onClick={() =>
          history.push(
            `${
              isNewRoute ? '/sales-conversation' : '/product/session'
            }/offers/overview/${riskObject}?session_id=${sessionId}`,
          )
        }
        level="secondary"
      >
        {t('Add a x insurance', { riskObj: t(riskObject) })}
      </LargeButton>
    </Container>
  );
};

const Title = styled.strong`
  font-weight: 500;
  margin-bottom: 0.8rem;
  font-size: 1.8rem;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.labels.guaranteeText};
  font-size: 1.6rem;
  line-height: 120%;
  margin-bottom: 2.4rem;
`;

const Container = styled.div`
  box-shadow: 0 0 2px rgba(40, 41, 61, 0.04), 0 4px 8px rgba(96, 97, 112, 0.16);
  border-radius: 6px;
  min-height: 21rem;
  padding: 4.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: white;
`;

export default SelectedOffersEmptyRiskObjContainer;
